export default "__VITE_ASSET__biy7DxZl__";